module.exports = __webpack_public_path__ + "img/waterdudv.25b38813.jpg";